import React, {useEffect, useRef, useState} from "react";
import CardTable from "../../components/table/CardTable";
import {Row} from "react-bootstrap";
import columns from "./config/MachineFormatPartTableConfig";
import CustomCard from "../../components/CustomCard";
import {MiniNavigation} from "../../components/nav/MiniNavigation";
import lineUtils from "../../helpers/lineUtils";
import { useTranslation } from 'react-i18next';

const MachineFormatParts = ({
                                machine,
                                setLoader,
                                reload,
                                additionalColumns,
                                checked,
                                setChecked,
                                externalConfigs,
                                externalConfigs2,
                                withHeader = true,
                                readOnly,
                                configurations,
                                checkAllByDefault,
                            }) => {
    const { t } = useTranslation();
    const [partsCount, setPartsCount] = useState();

    // Create dynamic refs for each category
    const categoryRefs = useRef(machine.formatPartsCategories.map(() => React.createRef()));

    // Define sections for MiniNavigation
    const sections = machine.formatPartsCategories
        .filter(m => m.formatParts.length > 0)
        .map((category, index) => ({
        ref: categoryRefs.current[index],
        name: category.category.id + "",
        menu: category.category.name,
    }));

    // Calculate parts count based on machine data
    useEffect(() => {
        const result = machine.formatPartsCategories.reduce((acc, arr) => acc + arr.formatParts.length, 0);
        setPartsCount(result);
    }, [machine]);


    useEffect(() => {
        if (checkAllByDefault && machine && !readOnly) {
            setChecked(lineUtils.collectAllFormatPartsForMachine(machine))
        }
    }, [machine, checkAllByDefault])

    return (
        <>


            {withHeader &&
                <Row>
                    <CustomCard width={12} withoutHeader={true}>
                        <strong>
                            {machine.formatPartsCategories.length > 0
                                ? t("common.format_parts")
                                : t("common.no_format_parts")}
                        </strong>
                        <div className="float-right">
                            <span className="text-secondary font-weight-normal">{t("forms.selected")}</span>
                            <span className={`badge badge-primary-outline mr-1 ml-1`}>
                            <span>{configurations.length + "/" + partsCount}</span>
                        </span>
                        </div>
                    </CustomCard>
                </Row>
            }
            <MiniNavigation
                defaultSection={sections[0]?.name} // Set the first category as default
                sections={sections}
            />
            {
                machine.formatPartsCategories
                    .filter(m => m.formatParts.length > 0)
                    .map((category, index) => (
                    <Row ref={categoryRefs.current[index]} className="mb-5" key={category.category.name}>
                        <CardTable
                            tittle={category.category.name}
                            initData={category.formatParts}
                            columns={additionalColumns ? columns(t).concat(additionalColumns) : columns(t)}
                            width={12}
                            setLoader={setLoader}
                            pagination={false}
                            reload={reload}
                            disableRule={(row) => {
                                return readOnly && !checked.includes(row.id);
                            }}
                            checked={checked}
                            setChecked={setChecked}
                            striped={false}
                            shadow={true}
                            readOnly={readOnly}
                            externalState={externalConfigs || configurations}
                            externalState2={externalConfigs2}
                        />
                    </Row>
                ))
            }
        </>
    );
};

export default MachineFormatParts;
